type AuthProvider = 'keycloak' | 'cognito'

const VALID_PROVIDERS: ReadonlySet<string> = new Set<AuthProvider>(['keycloak', 'cognito'])

/**
 * Validates that all required auth environment variables are present.
 * Throws an Error with an [Auth] prefix if validation fails.
 * Must be called before React mounts (in main.tsx).
 */
export function validateAuthConfig(): void {
  const provider = import.meta.env.VITE_AUTH_PROVIDER

  if (!provider) {
    throw new Error('[Auth] VITE_AUTH_PROVIDER is not set. Expected "keycloak" or "cognito".')
  }

  if (!VALID_PROVIDERS.has(provider)) {
    throw new Error(
      `[Auth] VITE_AUTH_PROVIDER="${provider}" is not a recognised provider. Expected "keycloak" or "cognito".`
    )
  }

  if (provider === 'keycloak') {
    const missing = (['VITE_KEYCLOAK_URL', 'VITE_KEYCLOAK_REALM', 'VITE_KEYCLOAK_CLIENT_ID'] as const).filter(
      (key) => !import.meta.env[key]
    )
    if (missing.length > 0) {
      throw new Error(`[Auth] Missing Keycloak configuration: ${missing.join(', ')}`)
    }
  }

  if (provider === 'cognito') {
    const missing = (['VITE_COGNITO_REGION', 'VITE_COGNITO_USER_POOL_ID', 'VITE_COGNITO_CLIENT_ID'] as const).filter(
      (key) => !import.meta.env[key]
    )
    if (missing.length > 0) {
      throw new Error(`[Auth] Missing Cognito configuration: ${missing.join(', ')}`)
    }
  }
}
